export default __webpack_public_path__ + "static/media/layer-planned-autodrive.03cd4742.svg";